<div class="flex min-h-0 flex-1 flex-col" [class.minimized]="isMinimized">
  <nav class="min-h-0 flex-1 overflow-y-auto" [class.py-6]="!isMinimized" [class.py-4]="isMinimized">
    <div
      [class.px-3]="!isMinimized"
      [class.px-1]="isMinimized"
      [class.space-y-6]="!isMinimized"
      [class.space-y-4]="isMinimized"
    >
      <div class="space-y-1">
        <p *ngIf="!isMinimized" class="px-3 text-[11px] font-bold uppercase tracking-[0.14em] text-neutral-400 dark:text-neutral-500">
          {{ "COMPONENTS.NAVBAR_BODY.SECTION_MAIN" | translate }}
        </p>

        @if (canViewStatistics$ | async) {
          <a
            [routerLink]="['statistics']"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{ exact: true }"
            [class.justify-center]="isMinimized"
            class="nav-link-item group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-neutral-600 transition-all hover:bg-accent-50 hover:text-primary-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-primary-400"
            [placement]="'right'"
            [ngbTooltip]="isMinimized ? ('COMPONENTS.NAVBAR_BODY.STATISTICS' | translate) : ''"
          >
            <svg class="h-5 w-5 shrink-0 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M4 19.5h16M7 16V9m5 7V6m5 10v-4"></path>
            </svg>
            <span *ngIf="!isMinimized" class="flex-1">{{ "COMPONENTS.NAVBAR_BODY.STATISTICS" | translate }}</span>
            <span class="nav-hover-indicator absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-600 opacity-0 transition-opacity"></span>
          </a>
        }

        @if (canViewEmployeesAssignments$ | async) {
          <a
            [routerLink]="['projects']"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{ exact: true }"
            [class.justify-center]="isMinimized"
            class="nav-link-item group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-neutral-600 transition-all hover:bg-accent-50 hover:text-primary-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-primary-400"
            [placement]="'right'"
            [ngbTooltip]="isMinimized ? ('COMPONENTS.NAVBAR_BODY.PROJECTS' | translate) : ''"
          >
            <svg class="h-5 w-5 shrink-0 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 7.5A1.5 1.5 0 0 1 4.5 6h5.2c.4 0 .78.16 1.06.44l1.5 1.5c.28.28.66.44 1.06.44H19.5A1.5 1.5 0 0 1 21 9.88v8.62A1.5 1.5 0 0 1 19.5 20h-15A1.5 1.5 0 0 1 3 18.5v-11Z"></path>
            </svg>
            <span *ngIf="!isMinimized" class="flex-1">{{ "COMPONENTS.NAVBAR_BODY.PROJECTS" | translate }}</span>
            <span class="nav-hover-indicator absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-600 opacity-0 transition-opacity"></span>
          </a>
        }
      </div>

      <div class="space-y-1">
        <p *ngIf="!isMinimized" class="px-3 text-[11px] font-bold uppercase tracking-[0.14em] text-neutral-400 dark:text-neutral-500">
          {{ "COMPONENTS.NAVBAR_BODY.SECTION_CLIENTS_AND_SALES" | translate }}
        </p>

        @if (canViewOrganizations$ | async) {
          <a
            [routerLink]="['crm', 'organizations']"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{ exact: false }"
            [class.justify-center]="isMinimized"
            class="nav-link-item group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-neutral-600 transition-all hover:bg-accent-50 hover:text-primary-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-primary-400"
            [placement]="'right'"
            [ngbTooltip]="isMinimized ? ('COMPONENTS.NAVBAR_BODY.ORGANIZATIONS' | translate) : ''"
          >
            <svg class="h-5 w-5 shrink-0 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3.5 20.5h17M5 20.5V4.5A1.5 1.5 0 0 1 6.5 3h11A1.5 1.5 0 0 1 19 4.5v16M8 7h2m4 0h2M8 11h2m4 0h2M8 15h2m4 0h2"></path>
            </svg>
            <span *ngIf="!isMinimized" class="flex-1">{{ "COMPONENTS.NAVBAR_BODY.ORGANIZATIONS" | translate }}</span>
            <span class="nav-hover-indicator absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-600 opacity-0 transition-opacity"></span>
          </a>
        }

        @if (canViewContacts$ | async) {
          <a
            [routerLink]="['crm', 'contacts']"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{ exact: false }"
            [class.justify-center]="isMinimized"
            class="nav-link-item group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-neutral-600 transition-all hover:bg-accent-50 hover:text-primary-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-primary-400"
            [placement]="'right'"
            [ngbTooltip]="isMinimized ? ('COMPONENTS.NAVBAR_BODY.CONTACTS' | translate) : ''"
          >
            <svg class="h-5 w-5 shrink-0 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7.5 8a7.5 7.5 0 0 1 15 0"></path>
            </svg>
            <span *ngIf="!isMinimized" class="flex-1">{{ "COMPONENTS.NAVBAR_BODY.CONTACTS" | translate }}</span>
            <span class="nav-hover-indicator absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-600 opacity-0 transition-opacity"></span>
          </a>
        }

        @if (canViewSalesOrders$ | async) {
          <a
            [routerLink]="['crm', 'sales-orders']"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{ exact: false }"
            [class.justify-center]="isMinimized"
            class="nav-link-item group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-neutral-600 transition-all hover:bg-accent-50 hover:text-primary-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-primary-400"
            [placement]="'right'"
            [ngbTooltip]="isMinimized ? ('COMPONENTS.NAVBAR_BODY.SALES_ORDERS' | translate) : ''"
          >
            <svg class="h-5 w-5 shrink-0 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M4.5 5.5h15A1.5 1.5 0 0 1 21 7v10a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 17V7a1.5 1.5 0 0 1 1.5-1.5Z"></path>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M7 9h10M7 12h6M7 15h4"></path>
            </svg>
            <span *ngIf="!isMinimized" class="flex-1">{{ "COMPONENTS.NAVBAR_BODY.SALES_ORDERS" | translate }}</span>
            <span class="nav-hover-indicator absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-600 opacity-0 transition-opacity"></span>
          </a>
        }

      </div>

      <div class="space-y-1">
        <p *ngIf="!isMinimized" class="px-3 text-[11px] font-bold uppercase tracking-[0.14em] text-neutral-400 dark:text-neutral-500">
          {{ "COMPONENTS.NAVBAR_BODY.SECTION_PRODUCTS_AND_WAREHOUSE" | translate }}
        </p>

        @if (canViewGoods$ | async) {
          <a
            [routerLink]="['crm', 'goods']"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{ exact: false }"
            [class.justify-center]="isMinimized"
            class="nav-link-item group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-neutral-600 transition-all hover:bg-accent-50 hover:text-primary-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-primary-400"
            [placement]="'right'"
            [ngbTooltip]="isMinimized ? ('COMPONENTS.NAVBAR_BODY.GOODS' | translate) : ''"
          >
            <svg class="h-5 w-5 shrink-0 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <line x1="16.5" y1="9.4" x2="7.5" y2="4.21" stroke-width="1.5"></line>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
              <polyline points="3.27 6.96 12 12.01 20.73 6.96" stroke-width="1.5"></polyline>
              <line x1="12" y1="22.08" x2="12" y2="12" stroke-width="1.5"></line>
            </svg>
            <span *ngIf="!isMinimized" class="flex-1">{{ "COMPONENTS.NAVBAR_BODY.GOODS" | translate }}</span>
            <span class="nav-hover-indicator absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-600 opacity-0 transition-opacity"></span>
          </a>
        }
      </div>

      <div class="space-y-1">
        <p *ngIf="!isMinimized" class="px-3 text-[11px] font-bold uppercase tracking-[0.14em] text-neutral-400 dark:text-neutral-500">
          {{ "COMPONENTS.NAVBAR_BODY.SECTION_TEAM" | translate }}
        </p>

        @if (canViewEmployees$ | async) {
          <a
            [routerLink]="['employees']"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{ exact: true }"
            [class.justify-center]="isMinimized"
            class="nav-link-item group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-neutral-600 transition-all hover:bg-accent-50 hover:text-primary-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-primary-400"
            [placement]="'right'"
            [ngbTooltip]="isMinimized ? ('COMPONENTS.NAVBAR_BODY.TEAM' | translate) : ''"
          >
            <svg class="h-5 w-5 shrink-0 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4" stroke-width="1.5"></circle>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            <span *ngIf="!isMinimized" class="flex-1">{{ "COMPONENTS.NAVBAR_BODY.TEAM" | translate }}</span>
            <span class="nav-hover-indicator absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-600 opacity-0 transition-opacity"></span>
          </a>
        }

        @if (canViewEmployeesAssignments$ | async) {
          <a
            [routerLink]="['employees-assignments']"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{ exact: true }"
            [class.justify-center]="isMinimized"
            class="nav-link-item group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-neutral-600 transition-all hover:bg-accent-50 hover:text-primary-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-primary-400"
            [placement]="'right'"
            [ngbTooltip]="isMinimized ? ('COMPONENTS.NAVBAR_BODY.TEAM_ASSIGNMENTS' | translate) : ''"
          >
            <svg class="h-5 w-5 shrink-0 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M8 4h8l4 4v11a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19V5.5A1.5 1.5 0 0 1 5.5 4H8Zm0 6h8m-8 4h8"></path>
            </svg>
            <span *ngIf="!isMinimized" class="flex-1">{{ "COMPONENTS.NAVBAR_BODY.TEAM_ASSIGNMENTS" | translate }}</span>
            <span class="nav-hover-indicator absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-600 opacity-0 transition-opacity"></span>
          </a>
        }

        @if (canViewKanban$ | async) {
          <a
            [routerLink]="['kanban-board']"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{ exact: true }"
            [class.justify-center]="isMinimized"
            class="nav-link-item group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-neutral-600 transition-all hover:bg-accent-50 hover:text-primary-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-primary-400"
            [placement]="'right'"
            [ngbTooltip]="isMinimized ? ('COMPONENTS.NAVBAR_BODY.ASSIGNMENT_SCHEDULE' | translate) : ''"
          >
            <svg class="h-5 w-5 shrink-0 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M7 2.5v3m10-3v3M4.5 6h15A1.5 1.5 0 0 1 21 7.5v12A1.5 1.5 0 0 1 19.5 21h-15A1.5 1.5 0 0 1 3 19.5v-12A1.5 1.5 0 0 1 4.5 6Zm0 5.5h15"></path>
            </svg>
            <span *ngIf="!isMinimized" class="flex-1">{{ "COMPONENTS.NAVBAR_BODY.ASSIGNMENT_SCHEDULE" | translate }}</span>
            <span class="nav-hover-indicator absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-600 opacity-0 transition-opacity"></span>
          </a>
        }
      </div>

      @if (canEditCompany$ | async) {
        <div class="space-y-1">
          <p *ngIf="!isMinimized" class="px-3 text-[11px] font-bold uppercase tracking-[0.14em] text-neutral-400 dark:text-neutral-500">
            {{ "COMPONENTS.NAVBAR_BODY.SECTION_SYSTEM" | translate }}
          </p>

          <a
            [routerLink]="['settings']"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{ exact: true }"
            [class.justify-center]="isMinimized"
            class="nav-link-item group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-neutral-600 transition-all hover:bg-accent-50 hover:text-primary-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-primary-400"
            [placement]="'right'"
            [ngbTooltip]="isMinimized ? ('COMPONENTS.NAVBAR_BODY.SETTINGS' | translate) : ''"
          >
            <svg class="h-5 w-5 shrink-0 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="3" stroke-width="1.5"></circle>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h0A1.65 1.65 0 0 0 10.4 3.09V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h0a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v0a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"></path>
            </svg>
            <span *ngIf="!isMinimized" class="flex-1">{{ "COMPONENTS.NAVBAR_BODY.SETTINGS" | translate }}</span>
            <span class="nav-hover-indicator absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-600 opacity-0 transition-opacity"></span>
          </a>

          <a
            [routerLink]="['settings', 'tariff-plan']"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{ exact: false }"
            [class.justify-center]="isMinimized"
            class="nav-link-item group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-neutral-600 transition-all hover:bg-accent-50 hover:text-primary-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-primary-400"
            [placement]="'right'"
            [ngbTooltip]="isMinimized ? ('COMPONENTS.NAVBAR_BODY.TARIFF' | translate) : ''"
          >
            <svg class="h-5 w-5 shrink-0 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 7.5A1.5 1.5 0 0 1 4.5 6h15A1.5 1.5 0 0 1 21 7.5v9A1.5 1.5 0 0 1 19.5 18h-15A1.5 1.5 0 0 1 3 16.5v-9Zm0 3h18"></path>
            </svg>
            <span *ngIf="!isMinimized" class="flex-1">{{ "COMPONENTS.NAVBAR_BODY.TARIFF" | translate }}</span>
            <span class="nav-hover-indicator absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-600 opacity-0 transition-opacity"></span>
          </a>
        </div>
      }
    </div>
  </nav>

  <div class="border-t border-neutral-200 dark:border-neutral-800" [class.p-3]="!isMinimized" [class.p-2]="isMinimized">
    <a
      id="return-button"
      [routerLink]="companiesLandingCommands"
      [class.justify-center]="isMinimized"
      class="nav-link-item group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-neutral-600 transition-all hover:bg-accent-50 hover:text-primary-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-primary-400"
      [placement]="'right'"
      [ngbTooltip]="isMinimized ? ('COMPONENTS.NAVBAR_BODY.RETURN' | translate) : ''"
    >
      <svg class="h-5 w-5 shrink-0 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M18 12H6m5-5-5 5 5 5"></path>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M18 5v14"></path>
      </svg>
      <span *ngIf="!isMinimized" class="flex-1">{{ "COMPONENTS.NAVBAR_BODY.RETURN" | translate }}</span>
      <span class="nav-hover-indicator absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-600 opacity-0 transition-opacity"></span>
    </a>
  </div>
</div>
